import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const List = () => import('../views/HomeworkTemplateList.vue')
const Edit = () => import('../views/HomeworkTemplateEdit.vue')
const Details = () => import('../views/HomeworkTemplateDetails.vue')

export const listRoute: RouteConfig = {
  path: 'template-list',
  name: 'homework_template_list',
  component: List,
  meta: {
    title: '作业计划',
  },
}

export const editRoute: RouteConfig = {
  path: 'template-edit',
  name: 'homework_template_edit',
  component: Edit,
  meta: {
    title: '作业计划',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const detailsRoute: RouteConfig = {
  path: 'template-details',
  name: 'homework_template_details',
  component: Details,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '作业计划',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const routes = [listRoute, editRoute, detailsRoute]

export function navigateToHomeworkTemplateList(router: VueRouter) {
  router.push({ name: listRoute.name })
}

export function navigateToHomeworkTemplateEdit(router: VueRouter) {
  router.push({ name: editRoute.name })
}

export function navigateToHomeworkTemplateDetails(router: VueRouter, id: string) {
  router.push({ name: detailsRoute.name, query: { id } })
}
